import React from "react"
import { Link } from "gatsby"
import { useColorModeValue } from "@mallardbay/lib-react-components"

import LogoDark from "~assets/images/logos/mb-logo-dark.svg"
import LogoLight from "~assets/images/logos/mb-logo-light.svg"
import Image, { type DashboardImageProps } from "~components/shared/image"

interface Props extends DashboardImageProps {
    readonly shouldRedirect?: boolean
}

export default function Logo({ shouldRedirect, style, ...props }: Props) {
    const logo = useColorModeValue(LogoDark, LogoLight)

    const imageElement = (
        <Image
            src={logo}
            alt="mallardbay-logo"
            style={{ width: "180px", ...style }}
            {...props}
        />
    )

    return shouldRedirect ? <Link to="/">{imageElement}</Link> : imageElement
}
